module.exports = __webpack_public_path__ + "static/hed-circle-4afa587e6377e9f63c0244b50622114b.png";